import styled from 'styled-components';

export const TicketsContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: ${(props) => props.theme.skillsAccordionBackground};
  border-left: 1px solid ${(props) => props.theme.skillsMainBorderColor};
  border-right: 1px solid ${(props) => props.theme.skillsMainBorderColor};
  border-bottom: 1px solid ${(props) => props.theme.skillsMainBorderColor};

  @media (max-width: 710px) {
    width: 100vw;
  }
`;

export const TicketsInnerContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const AddSkillsContainer = styled.div`
  height: 50px;
  background: ${({ theme }) => theme.feedbackContainersBackground};
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 1px 2px 0 rgba(0, 0, 0, 0.14);
  border-radius: 4px;
`;
